import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {AppEnum} from '../../constants/app.enum';

@Injectable({
  providedIn: 'root',
})
export class NetworkStatusService {
  private readonly onlineSubject = new BehaviorSubject<string>(AppEnum.NW_ONLINE);

  updateOnlineStatus(isOnline: string): void {
    this.onlineSubject.next(isOnline);
  }

  get onlineStatus$(): Observable<string> {
    return this.onlineSubject.asObservable();
  }
}
